import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const MafoQuestionFour: React.FC<MafoQuestionProps> = ({ register, errors, watch, setValue }) => {
	const questionFourValue = watch("question4")
	const hasOtherOptionSelected = Array.isArray(questionFourValue) ? questionFourValue.includes("h") : questionFourValue === "h"

	React.useEffect(() => {
		if (!hasOtherOptionSelected) {
			setValue("question4Other", "")
		}
	}, [hasOtherOptionSelected, setValue])

	return (
		<>
			<h3 className="mafo-headline text-left text-blue">4. Welche dieser Eigenschaften haben Dich besonders zum Kauf von TREK motiviert? (Mehrfachauswahl möglich)</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>9g Protein</>} className="pb-2 text-green lg:mt-6">
					<input type="checkbox" {...register("question4")} name="question4" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Hoher Ballaststoffgehalt</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Vegan/ pflanzlich</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Geschmack</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Natürliche Zutaten</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Natürliche Energiequelle </>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="f" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Bekannte Marke bzw. Kooperation mit Biscoff</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="g" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
					<ElemCheckboxMafo label={<>Sonstiges</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question4")} name="question4" value="h" className={"peer absolute hidden h-1 w-1 " + (errors.question4 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>

				{hasOtherOptionSelected && (
					<>
						<textarea {...register("question4Other")} name="question4Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2 border-blue border-[1px]"></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionFour
